import classNames from "classnames";
import React from "react";

import { getDescribedByElemID } from "./hooks/formUtils";

/**
 * Renders form field help text
 */
export const FormHelpText = (props: {
    id?: string;
    helpText?: string;
    helpTextClass?: string;
}): React.ReactNode => {
    if (!props.helpText || !props.id) {
        return null;
    }

    const helpTextClasses = classNames({
        "form__help-text": true,
        [`${props.helpTextClass}`]: !!props.helpTextClass,
    });

    return (
        <p
            className={helpTextClasses}
            id={getDescribedByElemID(props.id)}
            dangerouslySetInnerHTML={{ __html: props.helpText }}
        />
    );
};
